import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

export interface Props {
  search: string
  action: (value: string) => void
  actionLabel?: string
}

const Blank: React.FC<Props> = ({ search, action, actionLabel }) => {
  const onClickAction = () => {
    action(search)
  }

  return (
    <Box
      paddingY="s16"
      paddingX="s16"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      width="full"
      style={{ maxHeight: '56px' }}
    >
      <Text.Normal size="300" weight="medium" ellipsis color="grey800">
        {search}
      </Text.Normal>
      <Button type="secondary" onClick={onClickAction}>
        {actionLabel}
      </Button>
    </Box>
  )
}

export default Blank
